import React from 'react';

interface KeyboardTooHighProps {}

export function KeyboardTooHigh(props: Readonly<KeyboardTooHighProps>) {
	return (
		<svg width={109} height={89} viewBox="0 0 109 89" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_17129)">
				<path
					fill="#505A63"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M40.7 30.75h26.247c2.693 0 4.594 1.356 4.895 5.945l3.34 50.898c.3 4.591-2.207 5.947-4.896 5.947H37.363c-2.69 0-5.197-1.349-4.897-5.947l3.34-50.898c.302-4.598 2.202-5.945 4.895-5.945z"
				/>
				<mask x={30} y={30} width={46} height={64} maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }}>
					<path d="M30.918 30.75h44.695v62.863H30.918V30.75z" fill="#fff" />
				</mask>
				<path
					fill="#71828F"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M37 103v-3.727h-9.982V88H23v13.153c0 1.015.896 1.847 1.99 1.847H37z"
				/>
				<path
					fill="#505A63"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M21.968 73h5.97c.776 0 1.361.836 1.41 1.85L30 88.15c0 1.005-.636 1.85-1.41 1.85h-7.18c-.772 0-1.45-.834-1.408-1.85l.559-13.3c.04-1.016.632-1.85 1.407-1.85z"
				/>
				<path
					fill="#71828F"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M70 103v-3.727h10.695V88H85v13.153c0 1.015-.96 1.847-2.132 1.847H70z"
				/>
				<mask
					id="a"
					x={77}
					y={72}
					width={12}
					height={18}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M77.078 72.715h11.06v16.787h-11.06V72.715z" fill="#fff" />
				</mask>
				<g mask="url(#a)">
					<path
						fill="#505A63"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M85.959 72.742h-6.475c-.84 0-1.475.82-1.528 1.813l-.707 13.024c-.053.993.69 1.813 1.529 1.813h7.786c.84 0 1.559-1.255 1.513-2.25l-.591-12.587c-.045-.996-.687-1.813-1.527-1.813z"
					/>
				</g>
				<path fillRule="evenodd" clipRule="evenodd" d="M50 85h10v5H50v-5z" fill="#373D4A" />
				<path
					fill="#3E454A"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M30 88c0 1.797-.431 2-2.37 2h-5.813c-.583 0-1.937 0-1.808-2H30zM88 88c0 1.797-.431 2-2.37 2h-5.813c-.583 0-1.937 0-1.808-2H88z"
				/>
				<path
					fill="#999"
					d="M73.3 60.515c.373-.474 1.737-2.575 2.17-3.302.431-.727.973-1.611 1.387-2.459.446-.914 1.232-2.443 1.796-3.555.481-.95 2.828-5.169.11-8.366-1.383-1.195-1.268-2.504-4.227-3.171-4.222-.953-6.386 1.114-10.446-.476-1.915-.75-2.875-1.817-3.804-3.413-.322-.555.043-3.05 0-3.573-.04-.47-.505-.84-1.08-.84l-11.236-.016c-.585 0-1.076.377-1.09.856-.022.707.333 2.973 0 3.573-.499 1.325-2.122 2.634-4.454 3.413-2.318.873-3.95.476-8.055.476-1.516 0-3.17 1.317-4.227 2.114-.807.608-1.884 3.42-2.114 4.227-.231.809.649 2.584 1.393 4.528.745 1.945 1.778 3.594 1.944 4.068.165.475 1.157 2.616 1.488 3.226.33.61 1.257 2.21 1.406 2.4.15.191.868 1.288 1.158 1.762.165.305.678 1.259.827 1.559.304.612 2.694 4.646 2.9 6.137.298 2.146.539 6.536.539 9.102-.346 4.076-.337 10.38-2.143 19.01-.204.973-.148 2.139 0 3.494.41 3.746 3.003 9.067 17.393 9.067 14.389 0 16.556-7.881 16.704-9.067.149-1.186.184-2.037 0-3.494-.183-1.458-2.207-14.432-2.515-19.01-.133-1.99 0-7.064.308-9.102.342-2.267 1.652-5.535 2.846-7.577.237-.405.65-1.116 1.023-1.59z"
				/>
				<path
					fill="#7F7F7F"
					d="M79.199 71.41a4.72 4.72 0 001.605.837 4.35 4.35 0 001.754.148 4.138 4.138 0 002.907-1.753c.522-.74.9-1.995.854-2.577-.03-.38-.077-.901-.149-1.381-.135-.948-.323-1.458-.633-2.37-.63-1.832-.546-1.422-1.15-3.002-.507-2.004-1.043-3.636-1.69-7.491a49.046 49.046 0 00-1.822-7.381c-.21-.59-.413-1.144-.586-1.65l-.014-.06c-.281-.703-.534-1.357-.74-1.856a6.736 6.736 0 00-1.73-2.092 6.909 6.909 0 00-2.358-1.222 6.367 6.367 0 00-2.575-.207c-.853.108-1.682.295-2.398.839A4.938 4.938 0 0069.2 41.8c-.246.487-1.127 1.731-1.113 4.684.003.776.177 1.596.225 1.797.047.2-.046-.185 0 0 .505 2.128 1.223 4.016 2.136 5.942a28.033 28.033 0 001.842 3.31c.858 1.44 1.064 1.657 1.766 2.97.64 1.199 1.334 2.712 1.923 4.023.463 1.34 1.256 3.212 1.446 3.746.314.883.443 1.432.747 1.97.305.54.553.783 1.027 1.168zM47.396 11.323c1.107-.64 3.722-1.323 5.323-1.323 1.602 0 4.027.12 6.009 1.323 1.981 1.205 2.706 2.096 3.16 2.831.454.735 1.454 2.917 1.836 4.73.419 1.985.259 3.534.176 4.203-.214 1.715-1.158 4.644-1.963 6.053-.805 1.41-3.21 5.699-4.388 7.071C56.37 37.584 55.397 38 52.925 38c-2.189 0-3.598-1.25-4.563-2.28-.966-1.029-3.681-5.538-4.046-6.126-.366-.588-1.91-3.554-2.153-5.527-.243-1.972-.19-3.969 0-5.183s.99-3.296 1.94-4.73c.95-1.434 2.186-2.19 3.293-2.83zM27.977 71.792a4.72 4.72 0 01-1.605.838 4.35 4.35 0 01-1.754.148 4.138 4.138 0 01-2.908-1.753c-.521-.74-.9-1.995-.854-2.578.03-.378.078-.9.15-1.38.135-.948.323-1.458.633-2.37.63-1.832.546-1.422 1.15-3.003.506-2.003 1.043-3.636 1.69-7.49a49.07 49.07 0 011.822-7.382c.21-.589.412-1.143.585-1.648l.015-.062c.281-.703.533-1.357.74-1.855a6.734 6.734 0 011.73-2.092 6.906 6.906 0 012.358-1.222 6.365 6.365 0 012.575-.207c.853.108 1.681.294 2.397.839a4.938 4.938 0 011.275 1.607c.245.487 1.126 1.732 1.113 4.685-.003.776-.178 1.596-.225 1.797-.048.2.046-.186 0 0-.505 2.128-1.223 4.016-2.136 5.942a28.053 28.053 0 01-1.842 3.31c-.859 1.44-1.064 1.657-1.766 2.97-.64 1.198-1.334 2.712-1.923 4.023-.463 1.34-1.256 3.212-1.446 3.746-.314.882-.443 1.432-.747 1.97-.305.54-.553.783-1.027 1.167z"
				/>
				<mask
					id="b"
					x={0}
					y={71}
					width={110}
					height={19}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M0 71.813h109.114v17.766H0V71.813z" fill="#fff" />
				</mask>
				<g mask="url(#b)">
					<path d="M109.01 86.572v3.007H.012v-3.007l5.283-14.76h98.432l5.283 14.76z" fill="#BEC4CB" />
				</g>
				<path d="M0 87h109v3H0v-3z" fill="#6E7B88" />
				<path
					fill="#999"
					d="M26.853 77.235c-.429.129-.836.175-1.4.167-.562-.008-1.11.016-1.39.015-.465-.001-2.89.072-3.184-.132-.366-.254-.312-.954-.388-1.497-.229-1.619-.233-2.729-.236-3.642-.002-.701-.007-1.82.213-2.63.22-.808.872-1.171 1.248-1.39.376-.218 1.007-.462 1.932-.493 1.198.013 1.655.06 2.628.327.838.23 1.16.558 1.438.742.332.22.794.878.873 1.163.213.903.093 1.076-.23 1.982-.284.72-.282 1.094-.547 1.822-.241.811-.323 1.36-.339 1.779-.013.346.052 1.05.005 1.29-.046.24-.217.375-.623.497zM80.323 76.848c.429.13.836.175 1.399.168.563-.008 1.111.015 1.39.014.466-.001 2.891.072 3.185-.132.366-.254.311-.954.388-1.497.229-1.619.233-2.729.236-3.642.002-.7.007-1.82-.213-2.629-.22-.808-.872-1.172-1.248-1.39-.376-.219-1.007-.462-1.932-.493-1.198.012-1.655.06-2.629.326-.838.23-1.16.558-1.437.742-.332.22-.794.879-.873 1.163-.213.903-.093 1.077.23 1.982.283.72.282 1.095.547 1.823.241.81.323 1.359.338 1.778.014.347-.051 1.05-.005 1.29.047.24.218.375.624.497z"
				/>
				<path
					fill="#505A63"
					stroke="#505A63"
					strokeLinecap="round"
					d="M31.256 75.5L28.73 82h49.718l-3.172-6.5H31.255z"
				/>
				<path transform="matrix(-1 0 0 1 79.25 82.5)" fill="#71828F" d="M0 0H51.2495V1.24999H0z" />
				<path d="M64.25 81h2.25" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
				<path d="M64.25 79H66" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
				<path d="M64.25 77.25h1.5" stroke="#71828F" strokeWidth={0.4} strokeLinecap="round" />
				<path d="M69.25 81h2.25" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
				<path d="M69.25 79H71" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
				<path d="M69.25 77.25h1.5" stroke="#71828F" strokeWidth={0.4} strokeLinecap="round" />
				<path d="M59.25 81h2.25" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
				<path d="M59.25 79H61" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
				<path d="M59.25 77.25h1.5M53 75.75h12.5" stroke="#71828F" strokeWidth={0.4} strokeLinecap="round" />
				<path d="M54.25 81h2.25" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
				<path d="M54.5 79h1.75" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
				<path d="M54.5 77.25H56" stroke="#71828F" strokeWidth={0.4} strokeLinecap="round" />
				<path d="M49.25 81h2.25" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
				<path d="M49.5 79h1.75" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
				<path d="M49.75 77.25H51" stroke="#71828F" strokeWidth={0.4} strokeLinecap="round" />
				<path d="M30.5 81h2.25" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
				<path d="M31.125 79h1.75M31.75 77.25H33" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
				<path d="M35.5 81h2.25" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
				<path d="M36 79h1.75M36.375 77.25h1.25" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
				<path d="M40.5 81h2.25" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
				<path d="M40.75 79h1.75M41 77.25h1.25" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
				<path d="M74.25 81h2.25" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
				<path d="M74 79h1.75" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
				<path d="M73.5 77.25H75" stroke="#71828F" strokeWidth={0.4} strokeLinecap="round" />
				<path
					fill="#999"
					d="M24.725 83.739c1.275 0 2.08-.105 3.082-.865.705-.534.85-1.795 1.164-2.584.123-.31.862-.102 1.357-.662.439-.494.9-1.236.444-1.806-.55-.687-1.019-.331-1.646-.407-.34-.662-.47-1.257-1.28-1.603-.751-.321-1.294-.146-2.116-.051-.646.074-1.612.33-2.846.687-1.098.317-1.641.417-2.664.915-.678.331-1.347.847-1.461 1.476-.091.5.048.81.261 1.272.463 1.006.744 2.413 1.97 2.966 1.467.662 2.757.662 3.705.662h.03zM82.232 83.352c-1.275 0-2.08-.105-3.082-.865-.705-.534-.85-1.795-1.164-2.584-.123-.31-.862-.102-1.358-.661-.438-.495-.898-1.237-.443-1.807.55-.687 1.019-.33 1.646-.407.34-.662.47-1.257 1.28-1.603.751-.321 1.294-.145 2.116-.051.646.074 1.612.33 2.846.687 1.098.317 1.641.417 2.664.916.678.33 1.347.846 1.462 1.475.09.501-.05.81-.262 1.273-.463 1.005-.744 2.412-1.97 2.965-1.467.662-2.757.662-3.705.662h-.03z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_17129">
					<path fill="#fff" d="M0 0H109V89H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
